<script>
  import {RatesMenu} from "@util/constant.js"
  import LargeMenuItem from "./LargeMenuItem.svelte"

</script>


<LargeMenuItem Menu={RatesMenu} ColumnNumber={2} />
